// =============================================================================
// UploadIncomeStatementButton.js
// src/components/RPA/buttons/UploadIncomeStatementButton.js
// =============================================================================
import React, { useState, useRef } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

export default function UploadIncomeStatementButton({ docId, onDone, disabledHint }) {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file || !docId) return;

    setLoading(true);
    try {
      const formData = new FormData();

      // 👇 MUST match multer.single('incomeStatement') in uploadIncomeStatementController
      formData.append('incomeStatement', file);
      formData.append('docId', docId);

      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/income-statement/upload`,
        formData,
        {
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      );

      console.log('[UPLOAD_INCOME_STATEMENT_BTN] Success:', res.data);

      // RpaDashboard's onDone will schedule a debounced fetchDocs() refresh
      if (onDone) onDone(res.data);
    } catch (err) {
      console.error('[UPLOAD_INCOME_STATEMENT_BTN] Failed:', err);
      alert(err.response?.data?.message || 'Income statement upload failed');
    } finally {
      setLoading(false);
      // reset file input so you can re-upload the same file if needed
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <div style={{ display: 'inline-block' }}>
      <input
        ref={fileInputRef}
        type="file"
        accept=".xlsx,.xls,.csv"
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />
      <button
        onClick={() => fileInputRef.current?.click()}
        disabled={loading || !!disabledHint}
        title={disabledHint || 'Upload income statement (XLSX/XLS/CSV)'}
        style={{
          background: loading ? '#9ca3af' : (disabledHint ? '#fca5a5' : '#10b981'),
          color: 'white',
          border: 'none',
          padding: '4px 8px',
          borderRadius: 4,
          fontSize: 11,
          cursor: loading || disabledHint ? 'not-allowed' : 'pointer',
          fontWeight: 500
        }}
      >
        {loading ? 'Uploading...' : 'Upload Income Statement'}
      </button>
    </div>
  );
}